import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Button, Checkbox, Input, Modal, Select } from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { IconChecks, IconXboxX } from '@tabler/icons-react';
import { useEffect, useMemo, useState } from 'react';
import { createB2BAPI } from '../../../api/Interceptor';
import Navigation from '../sidebar/Navigation';
import './AddressesDetailsContent.css';
import states from '../../../utils/StatesAndDistricts.json'
import ky from 'ky';
import { useNavigate } from 'react-router-dom';
import { size } from 'lodash';
import { Country, State, City } from 'country-state-city';
const AddressesDetailsContent = () => {
    const navigate = useNavigate();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
    const [addresses, setAddresses] = useState([]);
    const [address, setAddress] = useState({});
    console.log(address, "dadd")
      const userId = JSON.parse(localStorage.getItem('user'))?.userId
      console.log(userId,"iuedern")
        const isMobile = useMediaQuery("(max-width: 767px)");
      const isCustomer = typeof userId === "string" && userId.startsWith("CUST-");
      const isVendor = typeof userId === "string" && userId.startsWith("VEN-") || /^B\d+$/.test(userId);
    const [errors, setErrors] = useState({});
    const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991px)');
    const [opened, { open, close }] = useDisclosure(false);
    const [loading, setLoading] = useState(false)
    const [companyName, setCompanyName] = useState('')
    const [transporter, setTransporter] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [isEdit, setIsEdit] = useState(false);


    const initialAddress = {
        nickName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        pincode: '',
        mobileNo: '',
        email: '',
        gstNo: ''
    };

    const handleEdit = (addr) => {
          setIsEdit(true);
        setAddress({
            ...addr,
            country: addr.country || '',
            state: addr.state || '',
            city: addr.city || '',
        });
        open();
    };
   const handleAdd = (addr) => {
        setIsEdit(false);
        setAddress({
            ...addr,
            country: addr.country || '',
            state: addr.state || '',
            city: addr.city || '',
        });
        open();
    };



    const validateAddress = () => {
        const newErrors = {};

        if (!address.nickName) newErrors.nickName = "Nickname is required";
        if (!/^[a-zA-Z\s]+$/.test(address.nickName)) newErrors.nickName = "Nickname must contain only letters";
        if (!address.address1) newErrors.address1 = "Street address is required";
        if (!address.city) newErrors.city = "City is required";
        // if (!/^[a-zA-Z\s]+$/.test(address.city)) newErrors.city = "City must contain only letters";
        if (!address.state) newErrors.state = "State is required";
        // if (!/^[a-zA-Z\s]+$/.test(address.state)) newErrors.state = "State must contain only letters";
        if (!address.pincode || !/^\d{5,9}$/.test(address.pincode)) newErrors.pincode = "Valid postal code is required";
        if (!address.country) newErrors.country = "Country is required";
        // if (!/^[a-zA-Z\s]+$/.test(address.country)) newErrors.country = "Country must contain only letters";
        if (!address.mobileNo || !/^\+?\d{10,15}$/.test(address.mobileNo)) newErrors.mobileNo = "Valid phone number is required";
        if (!address.email || !/\S+@\S+\.\S+/.test(address.email)) newErrors.email = "Valid email is required";
        // if (!address.gstNo || !address.isGstVerified) newErrors.gstNo = 'Enter Valid GST number'

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {
        if (!validateAddress()) return;

        try {
             const modified = {
                ...address,
                city: address.city,
                charge: 0,
                vendorId: userId
            }

            const res = isVendor ? await B2B_API.post('vendorLocations/save', { json: modified }).json(): await B2B_API.post(`customer/location`, { json: address });
            fetchAllAddresses();
            close();
        } catch (error) {
            console.error('Error on adding Address:', error);
        }
    };

    useEffect(() => {
        fetchAllAddresses();
        fetchTransporter();
    }, []);

    const fetchAllAddresses = async () => {
        try {
            const res =  isVendor ?await B2B_API.get(`vendorLocations?vendorId=${userId}`) : await B2B_API.get(`locations/customer`);
            const data = await res.json();
            const fetchedAddresses = data?.response || []
            const sortedAddresses = fetchedAddresses.sort((a, b) => {
                return new Date(b.createdDate) - new Date(a.createdDate);
            });

            setAddresses(sortedAddresses);
        } catch (error) {
            console.error('Error fetching Address:', error);
        }
    };

    const removeAddress = async (id) => {
        try {
            await B2B_API.delete(`locations/delete/${id}`);
            fetchAllAddresses();
        } catch (error) {
            console.error('Error removing address:', error);
        }
    };
    const primaryAddress = async (id) => {
        try {
            await B2B_API.get(`locations/primary/${id}`);
            fetchAllAddresses();
        } catch (error) {
            console.error('Error removing address:', error);
        }
    };

    const checkAndSetGstNo = async (value) => {
        if (value?.length > 15) return
        if (!value || value.length !== 15) {
            setAddress((prev) => ({ ...prev, gstNo: value, isGstVerified: false }));
            return;
        }
        setLoading(true)
        setAddress((prev) => ({ ...prev, gstNo: value }));
        try {
            const res = await ky.get(`http://sheet.gstincheck.co.in/check/2b0af50bb8281da1e460dc1ee82f1235/${value}`).json();
            setCompanyName(res.data.tradeNam)
            setAddress((prev) => ({
                ...prev,
                isGstVerified: res.flag, // Convert res.flag to boolean
            }));
            setErrors(prev => ({ ...prev, gstNo: '' }))
        } catch (error) {
            console.error('Error fetching GSTIN:', error);
            setAddress((prev) => ({
                ...prev,
                isGstVerified: false,
            }));
        } finally {
            setLoading(false)
        }
    };

    const getActionIconByGSt = (isGstVerified) => {
        return (<ActionIcon loading={loading} color='white' loaderProps={{ type: 'dots', color: 'blue' }}>
            {isGstVerified ? <IconChecks color='green' /> : <IconXboxX color='red' />}
        </ActionIcon>)
    }


    const getCityData = () => {
        const city = states[address?.state] ? states[address?.state] : [];
        return city.map(c => ({
            label: c,
            value: c
        }))
    }


    const fetchTransporter = async () => {
        try {
            const res = await B2B_API.get(`transporter/getTransporterByCity?city=${address.city}`).json();
            setTransporter(res.response)
        } catch (error) {
            console.error('Error fetching Transpoter data:', error);
        }
    }
    useEffect(() => {
        const countryList = Country.getAllCountries().map(country => ({
            value: country.name,
            label: country.name
        }));
        setCountries(countryList);
    }, []);


    useEffect(() => {
        if (address.country) {
            const countryObj = Country.getAllCountries().find(
                c => c.name === address.country
            );

            const stateList = State.getStatesOfCountry(countryObj?.isoCode || '')
                .map(state => ({
                    value: state.name,
                    label: state.name
                }));

            setStates(stateList);

            if (!address.state) {
                setAddress(prev => ({ ...prev, state: "", city: "" }));
                setCities([]);
            }
        } else {
            setStates([]);
            setCities([]);
        }
    }, [address.country]);

    useEffect(() => {
        const countryObj = Country.getAllCountries().find(
            c => c.name === address.country
        );

        const stateObj = countryObj
            ? State.getStatesOfCountry(countryObj.isoCode)
                .find(s => s.name === address.state)
            : null;

        if (countryObj && stateObj) {
            const cityList = City.getCitiesOfState(
                countryObj.isoCode,
                stateObj.isoCode
            ).map(city => ({
                value: city.name,
                label: city.name
            }));

            setCities(cityList);

            if (!address.city) {
                setAddress(prev => ({ ...prev, city: "" }));
            }
        } else {
            setCities([]);
        }
    }, [address.state]);


    const handleAddressCountryChange = (value) => {
        setAddress(prev => ({
            ...prev,
            country: value,
            state: '',
            city: '',
        }));
    };

    const handleAddressStateChange = (value) => {
        setAddress(prev => ({
            ...prev,
            state: value,
            city: '',
        }));
    };

    const handleAddressCityChange = (value) => {
        setAddress(prev => ({
            ...prev,
            city: value,
        }));
    };

    return (
        <div className="view-my-page router-view-container">
            {(!isMobile && !isTablet) && (
                <Navigation />
            )}
            <div className="view-addresses route-view">
                <div className="page-title m-b-32">Addresses</div>
                <div className="grid">
                    <div className="c-address-modifier">
                        <div className="empty-container">
                            <FontAwesomeIcon icon={faPlusCircle} className="c-gray-400 f-32" onClick={() => { handleAdd(initialAddress) }} />
                            <div className="f-16 f-600">Add Address</div>
                        </div>
                    </div>
                    {addresses?.map((addr) => (
                        <div key={addr.id} className="c-address-modifier">
                            <div className="c-address">
                                <div className="nickname">{addr.nickName}</div>
                                <div className="location-info">
                                    <div>{addr.address1}</div>
                                    <div>{addr.address2}</div>
                                    <div>{addr.city}, {addr.state} {addr.pincode}</div>
                                    <div className="country">{addr.country}</div>
                                </div>
                                <div className="contact-info">
                                    <div className="ci-row">
                                        <span className="address-key">Mobile No</span>
                                        <span className="address-value">{addr.mobileNo}</span>
                                    </div>
                                    <div className="ci-row">
                                        <span className="address-key">Email</span>
                                        <span className="address-value">{addr.email}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="function edit" onClick={() => { handleEdit(addr) }}>Edit</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '7rem' }}>
                                {addresses.length > 1 && addr.isPrimary === false && (
                                    <div className="function delete" onClick={() => removeAddress(addr.id)}>
                                        Remove
                                    </div>
                                )}
                                <div style={{ flexGrow: 1, textAlign: 'right' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', paddingBottom: '1rem', justifyContent: 'flex-end', paddingRight: '1rem' }}>
                                        <Checkbox
                                            type="checkbox"
                                            checked={addr.isPrimary}
                                            color='#8BC53F'
                                            size="xs"
                                            onChange={() => primaryAddress(addr.id)}
                                            style={{ marginRight: "8px", marginLeft: '1px' }}
                                        />
                                        Set as Primary
                                    </label>
                                </div>
                            </div>
                        </div>
                    ))}
                    <Modal
                        opened={opened}
                        onClose={() => {
                            setAddress({});
                            setErrors({});
                            close();
                        }}
                        title={isEdit ? "Edit Address" : "Add Address"}
                        centered
                    >
                        <div className="body">
                            <div className="form-address">
                                <div className="form-control required field-nickname" style={{ gap: "0px" }}>
                                    <label className="flex-row items-center m-b-4">
                                        <span className="flex-wrap">Location Nickname <span style={{ color: "red" }}> *</span></span>
                                    </label>
                                    <Input
                                        name="nickname"
                                        maxLength="20"
                                        value={address.nickName || ''}
                                        onChange={(e) => setAddress({ ...address, nickName: e.target.value })}
                                    />
                                    {errors.nickName && <div className="error-message" style={{ margin: "0px", color: "red" }}>{errors.nickName}</div>}
                                </div>
                                <div className="form-control required" style={{ gap: "0px" }}>
                                    <label className="display-block">Country <span style={{ color: "red" }}> *</span></label>
                                    <Select
                                        placeholder="Select country"
                                        value={address.country || ''}
                                        data={countries}
                                        searchable
                                        onChange={(value) => handleAddressCountryChange(value)}
                                    />
                                    {errors.country && <div className="error-message" style={{ color: "red" }}>{errors.country}</div>}
                                </div>
                                <div className="sub-destination">
                                    <div className="form-control flex-fill m-b-0 required">
                                        <Input.Wrapper label="State" error={errors.state} withAsterisk>
                                            <Select
                                                placeholder="Select State"
                                                value={address.state || ''}
                                                data={states}
                                                searchable
                                                onChange={(value) => handleAddressStateChange(value)}
                                            />
                                        </Input.Wrapper>
                                    </div>
                                    <div className="form-control flex-fill m-b-0 required">
                                        <Input.Wrapper label="City" error={errors.city} withAsterisk>
                                            <Select
                                                placeholder="Select City"
                                                value={address.city || ''}
                                                data={cities}
                                                searchable
                                                onChange={(value) => handleAddressCityChange(value)}
                                            />
                                        </Input.Wrapper>
                                    </div>
                                </div>
                                <div className="form-control required field-street-1" style={{ gap: "0px" }}>
                                    <label className="flex-row items-center">
                                        <span className="flex-wrap">Street 1  <span style={{ color: "red" }}> *</span></span>
                                    </label>
                                    <Input
                                        name="street1"
                                        placeholder="Street address, etc."
                                        maxLength="45"
                                        value={address.address1 || ''}
                                        onChange={(e) => setAddress({ ...address, address1: e.target.value })}
                                        disabled={address.isGstVerified}
                                    />
                                    {errors.address1 && <div className="error-message" style={{ color: "red" }}>{errors.address1}</div>}
                                </div>
                                <div className="form-control field-street-2" style={{ gap: "0px" }}>
                                    <label className="flex-row items-center">
                                        <span className="flex-wrap">Street 2</span>
                                    </label>
                                    <Input
                                        name="street2"
                                        placeholder="Suite, unit, building, floor, etc."
                                        maxLength="45"
                                        value={address.address2 || ''}
                                        onChange={(e) => setAddress({ ...address, address2: e.target.value })}
                                        disabled={address.isGstVerified}
                                    />
                                </div>

                                <div className="form-control required field-postal-code" style={{ gap: "0px" }}>
                                    <label className="flex-row items-center">
                                        <span className="flex-wrap">Postal code <span style={{ color: "red" }}> *</span></span>
                                    </label>
                                    <Input
                                        name="postalCode"
                                        maxLength="9"
                                        value={address.pincode || ''}
                                        onChange={(e) => setAddress({ ...address, pincode: e.target.value })}
                                        disabled={address.isGstVerified}
                                    />
                                    {errors.pincode && <div className="error-message" style={{ color: "red" }}>{errors.pincode}</div>}
                                </div>
                                <div className="input-phone form-control required field-phone" style={{ gap: "0px" }}>
                                    <label>Contact Phone <span style={{ color: "red" }}> *</span></label>
                                    <Input
                                        type="tel"
                                        name="phone"
                                        maxLength="11"
                                        value={address.mobileNo || ''}
                                        onChange={(e) => setAddress({ ...address, mobileNo: e.target.value })}
                                    />
                                    {errors.mobileNo && <div className="error-message" style={{ color: "red" }}>{errors.mobileNo}</div>}
                                </div>
                                <div className="form-control required field-recipient-email" style={{ gap: "0px" }}>
                                    <label className="flex-row items-center">
                                        <span className="flex-wrap">Contact Email <span style={{ color: "red" }}> *</span></span>
                                    </label>
                                    <Input
                                        name="recipientEmail"
                                        type="email"
                                        value={address.email || ''}
                                        onChange={(e) => setAddress({ ...address, email: e.target.value })}
                                    />
                                    {errors.email && <div className="error-message" style={{ color: "red" }}>{errors.email}</div>}
                                </div>
                                <div className="form-control required field-recipient-email" style={{ gap: "0px" }}>
                                    <Input.Wrapper label="Gst No" description={companyName} error={errors.gstNo} >
                                        <Input
                                            name="gstNo"
                                            type="text"
                                            disabled={address.isGstVerified}
                                            value={address.gstNo || ''}
                                            onChange={(e) => checkAndSetGstNo(e.target.value)}
                                            rightSection={getActionIconByGSt(address.isGstVerified)}
                                        />
                                    </Input.Wrapper>
                                </div>
                            </div>
                            <div className="bottom-buttons">
                                <Button variant="default" onClick={() => close()}>Cancel</Button>
                                <Button variant="filled" style={{ backgroundColor: '#8BC53F', color: 'white' }} onClick={handleSave}>Save</Button>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default AddressesDetailsContent;
